const PrintFormatTabLayout = [
    {
        "groupId": 1,
        "label": "All Transactions",
        "fields": [
            {
                "name": "PRINTEDITREPORT",
                "tableName": "",
                "label": "Edit Report",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }  
        ]
    },{
        "groupId": 2,
        "label": "Shipment Transactions",
        "fields": [
            {
                "name": "PRINTBOLFORMAT",
                "tableName": "",
                "label": "BOL - Regular",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTBOLFORMAT_SIMPLE",
                "tableName": "",
                "label": "BOL - Simple",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTBOLFORMAT_SPECIAL",
                "tableName": "",
                "label": "BOL - Special",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTPICKINGSLIPFORMAT",
                "tableName": "",
                "label": "Picking Slip",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTSHIPPINGLABEL",
                "tableName": "",
                "label": "Shipping Label",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTSERIALNUMBERLABEL",
                "tableName": "",
                "label": "Print Serial# Label",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTSSCCLABEL",
                "tableName": "",
                "label": "Print SSCC Label",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTPICKINGSLIPSEQUENCE",
                "tableName": "",
                "label": "Print Picking Sequence",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTSERIALNOMANIFESTREV",
                "tableName": "",
                "label": "Print Serial# Mainfest",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }  
        ]
    },{
        "groupId": 3,
        "label": "Receipt Transactions",
        "fields": [
            {
                "name": "PRINTPUTAWAY",
                "tableName": "",
                "label": "Putaway",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTRECEIVINGLABEL",
                "tableName": "",
                "label": "Recive Label Location",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "PRINTRECEIPTCONFIRMATION",
                "tableName": "",
                "label": "Print Receipt Confirmation",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }  
        ]
    },{
        "groupId": 4,
        "label": "Navigation Reports",
        "fields": [
            {
                "name": "NAVREPORT1STATUS",
                "tableName": "",
                "label": "Rpt1 Status",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT1TEXT",
                "tableName": "",
                "label": "Rpt1 Text",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT1TYPE",
                "tableName": "",
                "label": "Rpt1 Type",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT1NAME",
                "tableName": "",
                "label": "Rpt1 Name",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT1FORMAT",
                "tableName": "",
                "label": "Rpt1 Format",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
            
              {
                "name": "NAVREPORT2STATUS",
                "tableName": "",
                "label": "Rpt2 Status",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT2TEXT",
                "tableName": "",
                "label": "Rpt2 Text",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT2TYPE",
                "tableName": "",
                "label": "Rpt2 Type",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT2NAME",
                "tableName": "",
                "label": "Rpt2 Name",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT2FORMAT",
                "tableName": "",
                "label": "Rpt2 Format",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
            
              {
                "name": "NAVREPORT3STATUS",
                "tableName": "",
                "label": "Rpt3 Status",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT3TEXT",
                "tableName": "",
                "label": "Rpt3 Text",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT3TYPE",
                "tableName": "",
                "label": "Rpt3 Type",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT3NAME",
                "tableName": "",
                "label": "Rpt3 Name",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT3FORMAT",
                "tableName": "",
                "label": "Rpt3 Format",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
            
              {
                "name": "NAVREPORT4STATUS",
                "tableName": "",
                "label": "Rpt4 Status",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT4TEXT",
                "tableName": "",
                "label": "Rpt4 Text",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT4TYPE",
                "tableName": "",
                "label": "Rpt4 Type",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT4NAME",
                "tableName": "",
                "label": "Rpt4 Name",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              },
              {
                "name": "NAVREPORT4FORMAT",
                "tableName": "",
                "label": "Rpt4 Format",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": true
              }
        ]
    }  
];

export {
    PrintFormatTabLayout,
    }
